import ComponentPermissionGuard from './component-permission-guard';

export default ComponentPermissionGuard;